<mat-radio-group class="align-top" fxLayout="row wrap">
  <ng-container *ngFor="let group of groups$ | async | keyvalue">
    <ng-container
      *ngTemplateOutlet="
        group.key === 'TX' ? texasGroup : column;
        context: { group: group.value }
      "
    >
    </ng-container>
  </ng-container>
</mat-radio-group>

<ng-template #column let-group="group">
  <ng-container *ngIf="group.disposalSites.length > 0">
    <div class="input-container" fxFlex="0 0 100%">
      <label>{{ group.title }}</label>
      <div fxLayout="row wrap">
        <mat-radio-button
          fxFlex="1 0 50%"
          *ngFor="let disposalSite of group.disposalSites"
          [value]="disposalSite.id"
          [checked]="value?.id === disposalSite.id"
          [disabled]="disposalSite.disabledReason !== ''"
          [matTooltip]="disposalSite.disabledReason"
          [matTooltipDisabled]="!disposalSite.disabledReason"
          (change)="onChange($event)"
        >
          {{ disposalSite.name }}
          <digital-platform-address
            class="sub-text inline-address"
            [address]="disposalSite.address"
            [oneLine]="true"
          ></digital-platform-address>
        </mat-radio-button>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #texasGroup let-group="group">
  <ng-container *ngIf="group.disposalSites.length > 0">
    <div class="input-container" fxFlex="0 0 100%">
      <label>{{ group.title }}</label>
      <div class="texas-sites" fxLayout="row wrap">
        <ng-container *ngFor="let subGroup of group.subGroups | keyvalue">
          <ng-container
            *ngTemplateOutlet="column; context: { group: subGroup.value }"
          >
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>
